import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { I as InlineAlertMessage, a as InlineAlertIconWrapper, b as InlineAlertIcon, c as InlineAlertText } from './InlineAlert.styles-DaVrbi51.js';
import { e as exclamationTriangle, c as check, o as opportunity, s as spinner, i as infoCircle, a as exclamation } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-t7qtQAY6-Bxh9jPb6.js';

const MessageIconMap = {
  error: exclamation,
  info: infoCircle,
  loading: spinner,
  opportunity,
  success: check,
  warning: exclamationTriangle
};
const InlineAlert = ({
  variant,
  message,
  ...rest
}) => /*#__PURE__*/React__default.createElement(InlineAlertMessage, _extends({
  $variant: variant
}, rest), variant && MessageIconMap[variant] && /*#__PURE__*/React__default.createElement(InlineAlertIconWrapper, null, /*#__PURE__*/React__default.createElement(InlineAlertIcon, {
  type: MessageIconMap[variant],
  size: "small",
  $variant: variant
})), /*#__PURE__*/React__default.createElement(InlineAlertText, {
  color: "secondary"
}, message));

/** @deprecated This will be removed in StormUI 5.x. Use `InlineAlert` instead. */
const InlineMessage = InlineAlert;

export { InlineAlert as I, InlineMessage as a };
//# sourceMappingURL=InlineAlert-c5UFTCEp.js.map
